import { RackViewComponent } from './rack/rack.component';
import { AdjustableSeatViewComponent } from './seat/seat.component';
import { TableViewComponent } from './table/table.component';
import { OverheadStorageViewComponent } from './overheadstorage/overheadstorage.component';
import { NonUseablespaceViewComponent } from './nonuseablespace/nonuseablespace.component';
import { WallViewComponent } from './wall/wall.component';
import { InnerdoorViewComponent } from './innerdoor/innerdoor.component';
import { EntrancedoorViewComponent } from './entrancedoor/entrancedoor.component';
import { GangwaydoorViewComponent } from './gangwaydoor/gangwaydoor.component';
import { StairViewComponent } from './stair/stair.component';
import { BedViewComponent } from './bed/bed.component';
import { ViewComponentNames } from '../helper/viewComponentNames';
import { SeatwithstorageViewComponent } from './seatwithstorage/seatwithstorage.component';
import { TablewithstorageViewComponent } from './tablewithstorage/tablewithstorage.component';
import { MultiPurposeAreaViewComponent } from './multipurposearea/multipurposearea.component';
import { AisleViewComponent } from './aisle/aisle.component';
import { PTseatViewComponent } from './ptseat/ptseat.component';

export const COMPONENT_MAP: Map<any, any> = new Map();
COMPONENT_MAP.set(ViewComponentNames.bedViewComponent, BedViewComponent);
COMPONENT_MAP.set(ViewComponentNames.luggageAreaViewComponent, null);
COMPONENT_MAP.set(ViewComponentNames.nonUseableSpaceViewComponent, NonUseablespaceViewComponent);
COMPONENT_MAP.set(ViewComponentNames.overheadStorageViewComponent, OverheadStorageViewComponent);
COMPONENT_MAP.set(ViewComponentNames.rackViewComponent, RackViewComponent);
COMPONENT_MAP.set(ViewComponentNames.adjustableSeatViewComponent, AdjustableSeatViewComponent);
COMPONENT_MAP.set(ViewComponentNames.stairViewComponent, StairViewComponent);
COMPONENT_MAP.set(ViewComponentNames.tableViewComponent, null);
COMPONENT_MAP.set(ViewComponentNames.wallViewComponent, WallViewComponent);
COMPONENT_MAP.set(ViewComponentNames.entranceDoorViewComponent, EntrancedoorViewComponent);
COMPONENT_MAP.set(ViewComponentNames.seatWithStorageViewComponent, SeatwithstorageViewComponent);
COMPONENT_MAP.set(ViewComponentNames.aisleViewComponent, AisleViewComponent);
COMPONENT_MAP.set(ViewComponentNames.innderDoorViewComponent, null);
COMPONENT_MAP.set(ViewComponentNames.gangwayDoorViewComponent, GangwaydoorViewComponent);
COMPONENT_MAP.set(ViewComponentNames.tableWithStorageViewComponent, TablewithstorageViewComponent);
COMPONENT_MAP.set(ViewComponentNames.multipurposeareaViewComponent, MultiPurposeAreaViewComponent);
COMPONENT_MAP.set(ViewComponentNames.adjustablePTSeatViewComponent, PTseatViewComponent);
COMPONENT_MAP.set(ViewComponentNames.wheelChairBoardingDeviceViewComponent, null);
COMPONENT_MAP.set(ViewComponentNames.cornerBenchViewComponent, null);
COMPONENT_MAP.set(ViewComponentNames.elementsInEntranceAreaViewComponent, null);
